<template>
    <div>
        <v-row class="mt-8">
            <v-col>
                <div class="text-h3 primary--text">HOW TO HIRE</div>
                <div class="text-h6 secondary--text">
                    It’s easy! Here’s how it works:
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-timeline align-top :dense="$vuetify.breakpoint.mobile">
                    <v-timeline-item
                        v-for="(item, i) in howToHire"
                        :key="i"
                        :icon="item.icon"
                        fill-dot
                    >
                        <v-card color="secondary" dark>
                            <v-card-title class="text-h6" v-html="item.title" />
                            <v-card-text
                                class="white text--primary pt-2"
                                v-html="item.body"
                            />
                            <v-card-actions
                                v-if="item.showPaymentLogo"
                                class="white d-flex justify-center"
                            >
                                <v-img
                                    max-width="250px"
                                    width="50%"
                                    min-width="100px"
                                    :src="$page.props.statics.payment_logo"
                                />
                            </v-card-actions>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="d-flex flex-column">
                <v-img
                    height="50px"
                    contain
                    :src="$page.props.statics.footer_image"
                />
                <div class="text-caption mt-4">
                    All prices are exclusive of VAT and are correct at time of
                    publishing this catalogue. To the best of our knowledge, all
                    of the information contained within these Hire Catalogues is
                    correct. King Sound Reinforcement Ltd does not accept any
                    liability for any loss or damage to hired equipment, however
                    it occurred.
                    <br /><br />
                    Transactions are subject to our terms and conditions of
                    business. Full Terms and Conditions are available on
                    request.
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <contact-form
                    origin="Can't find what you are looking for? form"
                >
                    <v-row>
                        <v-col>
                            <div class="text-h3 primary--text my-2">
                                Can't find what you are looking for?
                            </div>
                            <div class="text-h6 secondary--text my-2">
                                Get in touch and our team can help you
                            </div>
                        </v-col>
                    </v-row>
                </contact-form>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ContactForm from "@/Components/Catalogue/ContactForm";

export default {
    name: "HowToHire",
    components: { ContactForm },

    data() {
        return {
            howToHire: [
                {
                    icon: "mdi-phone",
                    title: "1. Getting In Touch",
                    body: `If you are not sure what you need please <strong>give us a call</strong> on
                        <a href="tel:${this.$page.props.company_info.int_phone}">${this.$page.props.company_info.phone}</a>
                        or email with an outline of your requirements and a rough budget — we can then advise you on
                        your best options.
                        <br><br>
                        Should you already know what you need, please call or email us at
                        <a href="mailto:${this.$page.props.company_info.email}">${this.$page.props.company_info.email}</a>
                        with your requirements. One of our team will check the availability of the equipment and email
                        you back with a quotation.`,
                },
                {
                    icon: "mdi-card-account-mail-outline",
                    title: "2. Contact Details",
                    body: `There are a few things we are going to want to know from you before providing a quote or placing
                        a hire booking:

                        <ul>
                            <li><strong>Name</strong></li>
                            <li><strong>Business or Organisation Name</strong></li>
                            <li><strong>Contact Number</strong></li>
                            <li><strong>Billing Details:</strong> name, address and email, purchase order number.</li>
                            <li><strong>Hire Period:</strong> please specify collection and return dates, or the
                                delivery and collection dates
                                from site or venue.
                            </li>
                        </ul>

                        New customers will also need to bring in some form of photo ID (a driving licence or passport)
                        and proof of address.`,
                },
                {
                    icon: "mdi-package-variant-closed",
                    title: "3. Delivery / Collection & Return",
                    body: `<strong>Delivery/collection within 10 miles of Bristol is £20+VAT each way, Mon-Fri 9am-6pm.</strong>
                        <br><br>
                        King Sound Reinforcement also offers free delivery within Bristol on orders over £150+VAT during
                        office hours. Deliveries and collections outside of Bristol are available upon request.
                        Customers are also welcome to collect and return equipment directly to our warehouse in Bristol
                        during business hours.`,
                },
                {
                    icon: "mdi-contactless-payment",
                    title: "4. Payment",
                    body: `Payment is easy: <strong>we can process Credit or Debit card payments</strong> in person or over the phone. We
                        also accept bank transfers and cash. We ask non account customers for payment on commencement of
                        hire.`,
                    showPaymentLogo: true,
                },
                {
                    icon: "mdi-check-circle-outline",
                    title: "5. Hire Confirmation",
                    body: `<strong>A hire confirmation will be sent via email,</strong> please ensure the contact details, transport
                        arrangements, hire period and the equipment specified are correct. Equipment is subject to
                        availability at the time of order. Equipment is the responsibility of the hirer from collection
                        or delivery.`,
                },
            ],
        };
    },
};
</script>

<style scoped></style>
